import React from "react";
import { PrefillInput } from "@components/input";

const MobilePhone = () => (
  <PrefillInput
    title="Mobile Number"
    type="number"
    inputMode="numeric" /* tel would be more correct but currently we dont support +61 and this encorages it */
    placeholder="Mobile Number"
    maxLength={10}
    name="mobilePhone"
  />
);

export default MobilePhone;
